import React from "react";
import { getImgPath, handleImgError } from "../helper";
export const renderImg = (img) => {
    switch (img) {
        case 'Swift-gajraj-thumb':
            return <img style={{ borderRadius: '100%' }} src={getImgPath('/img/Swift-gajraj-thumb.png')} onError={handleImgError} />
        case 'Swift-Garuda-thumb':
            return <img style={{ borderRadius: '100%' }} src={getImgPath('/img/Swift-Garuda-thumb.png')} onError={handleImgError} />
        case 'Swift-deluxe-thumb':
            return <img style={{ borderRadius: '100%' }} src={getImgPath('/img/Swift-deluxe-thumb.png')} onError={handleImgError} />
        case 'ksrtc-thumb':
            return <img style={{ borderRadius: '100%' }} src={getImgPath('/img/ksrtc-thumb.png')} onError={handleImgError} />
        case 'seat':
            return <img src={getImgPath('/img/seat.svg')} onError={handleImgError} />
        case 'AcIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/AcIcon.svg')} onError={handleImgError} />
        case 'NonAcIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/NonAcIcon.svg')} onError={handleImgError} />
        case 'seatErrorIcon':
            return <img src={getImgPath('/img/seatErrorIcon.svg')} onError={handleImgError} />
        case 'filterIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/filterIcon.svg')} onError={handleImgError} />
        case 'SortIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/SortIcon.svg')} onError={handleImgError} />
        case 'covid':
            return <img src={getImgPath('/img/covid.svg')} onError={handleImgError} />
        case 'tip':
            return <img src={getImgPath('/img/tip.png')} onError={handleImgError} />
        case 'Driver':
            return <img src={getImgPath('/img/Driver.svg')}
                style={{
                    position: 'absolute', top: '-55px', left: '50%', transform: 'translateX(-50%)'
                }} onError={handleImgError} />
        case 'Shield':
            return <img src={getImgPath('/img/Shield.svg')}
                style={{
                    marginRight: '5px', marginLeft: '-7px'
                }} onError={handleImgError} />
        case 'clock':
            return <img style={{ marginRight: '3px' }} src={getImgPath('/img/clock.svg')} onError={handleImgError} />
        case 'TripIcon':
            return <img src={getImgPath('/img/TripIcon.svg')} onError={handleImgError} />
        case 'TickIcon':
            return <img src={getImgPath('/img/TickIcon.svg')} onError={handleImgError} />
        case 'SearchIcon':
            return <img src={getImgPath('/img/SearchIcon.svg')}
                style={{
                    position: 'absolute',
                    left: '30px',
                    fill: '#666',
                    height: '18px',
                    width: '18px',
                    top: '25px',
                    zIndex: '1'
                }}
                onError={handleImgError} />
        case 'NoCoupon':
            return <img src={getImgPath('/img/NoCoupon.svg')} onError={handleImgError} />
        case 'GiftIcon':
            return <img style={{ marginRight: "5px" }} src={getImgPath('/img/GiftIcon.svg')} onError={handleImgError} />
        case 'offer':
            return <img src={getImgPath('/img/offer.png')} alt='offer' onError={handleImgError} />
        case 'LoginAside':
            return <img src={getImgPath('/img/LoginAside.svg')} onError={handleImgError} />
        case 'Info':
            return <img style={{ marginRight: '15px' }} src={getImgPath('/img/Info.svg')} onError={handleImgError} />
        case 'WarningIcon':
            return <img src={getImgPath('/img/WarningIcon.svg')} onError={handleImgError} />
        case 'Phonepe':
            return <img src={getImgPath('/img/Phonepe.png')} onError={handleImgError} />
        case 'Billdesk':
            return <img src={getImgPath('/img/Billdesk.png')} onError={handleImgError} />
        case 'razorpay':
            return <img src={getImgPath('/img/razorpay.png')} onError={handleImgError} />
        case 'easebuzz':
            return <img src={getImgPath('/img/easebuzz.png')} onError={handleImgError} />    
        case 'PgSelectedTick':
            return <img src={getImgPath('/img/PgSelectedTick.svg')} onError={handleImgError} />
        case 'alarm':
            return <img src={getImgPath('/img/alarm.svg')} onError={handleImgError} />
        case 'blanket':
            return <img src={getImgPath('/img/blanket.svg')} onError={handleImgError} />
        case 'bottle-holder':
            return <img src={getImgPath('/img/blanket.svg')} onError={handleImgError} />
        case 'cctv':
            return <img src={getImgPath('/img/cctv.svg')} onError={handleImgError} />
        case 'charger':
            return <img src={getImgPath('/img/charger.svg')} onError={handleImgError} />
        case 'emergency-exit':
            return <img src={getImgPath('/img/emergency-exit.svg')} onError={handleImgError} />
        case 'extra-leg':
            return <img src={getImgPath('/img/extra-leg.svg')} onError={handleImgError} />
        case 'fan':
            return <img src={getImgPath('/img/fan.svg')} onError={handleImgError} />
        case 'fire-extinguisher':
            return <img src={getImgPath('/img/fire-extinguisher.svg')} onError={handleImgError} />
        case 'first-aid-box':
            return <img src={getImgPath('/img/first-aid-box.svg')} onError={handleImgError} />
        case 'gps':
            return <img src={getImgPath('/img/gps.svg')} onError={handleImgError} />
        case 'hammer':
            return <img src={getImgPath('/img/hammer.svg')} onError={handleImgError} />
        case 'heater':
            return <img src={getImgPath('/img/heater.svg')} onError={handleImgError} />
        case 'meal':
            return <img src={getImgPath('/img/meal.svg')} onError={handleImgError} />
        case 'news-paper':
        case 'newspaper':
            return <img src={getImgPath('/img/newspaper.svg')} onError={handleImgError} />
        case 'novel':
            return <img src={getImgPath('/img/novel.svg')} onError={handleImgError} />
        case 'pillow':
            return <img src={getImgPath('/img/pillow.svg')} onError={handleImgError} />
        case 'personal-tv':
            return <img src={getImgPath('/img/personal-tv.svg')} onError={handleImgError} />
        case 'reading-light':
            return <img src={getImgPath('/img/reading-light.svg')} onError={handleImgError} />
        case 'seat':
            return <img src={getImgPath('/img/seat.svg')} onError={handleImgError} />
        case 'snacks':
            return <img src={getImgPath('/img/snacks.svg')} onError={handleImgError} />
        case 'tissue':
            return <img src={getImgPath('/img/tissue.svg')} onError={handleImgError} />
        case 'toilet':
            return <img src={getImgPath('/img/toilet.svg')} onError={handleImgError} />
        case 'tv':
            return <img src={getImgPath('/img/tv.svg')} onError={handleImgError} />
        case 'central-tv':
            return <img src={getImgPath('/img/central-tv.svg')} onError={handleImgError} />
        case 'vomiting-bag':
            return <img src={getImgPath('/img/vomiting-bag.svg')} onError={handleImgError} />
        case 'water-bottle':
            return <img src={getImgPath('/img/water-bottle.svg')} onError={handleImgError} />
        case 'wifi':
            return <img src={getImgPath('/img/wifi.svg')} onError={handleImgError} />
        case 'charging-point':
            return <img src={getImgPath('/img/charging-point.svg')} onError={handleImgError} />
        case 'extra-leg-space':
            return <img src={getImgPath('/img/extra-leg-space.svg')} onError={handleImgError} />
        case 'water-bottle-holder':
            return <img src={getImgPath('/img/water-bottle-holder.svg')} onError={handleImgError} />
        case 'messager-seat':
            return <img src={getImgPath('/img/messager-seat.svg')} onError={handleImgError} />
        case 'juices':
            return <img src={getImgPath('/img/juices.svg')} onError={handleImgError} />
        case 'facial-tissues':
            return <img src={getImgPath('/img/facial-tissues.svg')} onError={handleImgError} />
        case 'Ac':
            return <img src={getImgPath('/img/Ac.svg')} onError={handleImgError} />
        case 'NonAc':
            return <img src={getImgPath('/img/NonAc.svg')} onError={handleImgError} />
        case 'Seater':
            return <img src={getImgPath('/img/Seater.svg')} onError={handleImgError} />
        case 'Sleeper':
            return <img src={getImgPath('/img/Sleeper.svg')} onError={handleImgError} />
        case 'Morning':
            return <img style={{ marginRight: '10px' }} src={getImgPath('/img/Morning.svg')} onError={handleImgError} />
        case 'Afternoon':
            return <img style={{ marginRight: '10px' }} src={getImgPath('/img/Afternoon.svg')} onError={handleImgError} />
        case 'Evening':
            return <img style={{ marginRight: '10px' }} src={getImgPath('/img/Evening.svg')} onError={handleImgError} />
        case 'PhoneIcon':
            return <img src={getImgPath('/img/PhoneIcon.svg')} onError={handleImgError} />
        case 'CloseIcon':
            return <img src={getImgPath('/img/CloseIcon.svg')} onError={handleImgError} />
        case 'CloseIconActive':
            return <img src={getImgPath('/img/closeIconActive.svg')} onError={handleImgError} />
        case 'CalendarIcon':
            return <img src={getImgPath('/img/CalendarIcon.svg')} onError={handleImgError} />
        case 'CalendarIconBlue':
            return <img src={getImgPath('/img/ic-cal.svg')} onError={handleImgError} />
        case 'SwapIcon':
            return <img src={getImgPath('/img/SwapIcon.svg')} onError={handleImgError} />
        case 'ViewEyeIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/ViewEyeIcon.svg')} onError={handleImgError} />
        case 'StationIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/StationIcon.svg')} onError={handleImgError} />
        case 'StationIconBlue':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/StationIconBlue.svg')} onError={handleImgError} />
        case 'BusIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/BusIcon.svg')} onError={handleImgError} />
        case 'BusIconGray':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/ic-bus-gray.svg')} onError={handleImgError} />
        case 'BerthIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/BerthIcon.svg')} onError={handleImgError} />
        case 'SeatIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/SeatIcon.svg')} onError={handleImgError} />
        case 'WheelIcon':
            return <img style={{ position: 'absolute', top: '21px', left: '24px' }} src={getImgPath('/img/WheelIcon.svg')} onError={handleImgError} />
        case 'TickMarkIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/TickMarkIcon.svg')} onError={handleImgError} />
        case 'TripIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/TripIcon.svg')} onError={handleImgError} />
        case 'SeatErrorIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/SeatErrorIcon.svg')} onError={handleImgError} />
        case 'GsbLogoBold':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/GsbLogoBold.svg')} onError={handleImgError} />
        case 'PickupIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/PickupIcon.svg')} onError={handleImgError} />
        case 'DropoffIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/DropoffIcon.png')} onError={handleImgError} />
        case 'TripMarkIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/TripMarkIcon.svg')} onError={handleImgError} />
        case 'CouponArrow':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/CouponArrow.svg')} onError={handleImgError} />
        case 'CouponInfo':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/CouponInfo.svg')} onError={handleImgError} />
        case 'WhiteCross':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/WhiteCross.svg')} onError={handleImgError} />
        case 'SideArrow':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/SideArrow.svg')} onError={handleImgError} />
        case 'FemaleSeatIcon':
            return <img style={{ marginRight: '5px' }} src={getImgPath('/img/FemaleSeatIcon.svg')} onError={handleImgError} />
        case 'Securelogo':
            return <img src={getImgPath('/img/Securelogo.svg')} onError={handleImgError} />
        case 'paymentMsg':
            return <img src={getImgPath('/img/paymentMsg.png')} onError={handleImgError} />
        case 'CloseIconWhite':
            return <img src={getImgPath('/img/CloseIconWhite.svg')} onError={handleImgError} />
        case 'eyeclose':
            return <img src={getImgPath('/img/eyeclose.png')} onError={handleImgError} style={{ position: "absolute", right: '10px', bottom: '10px', cursor: 'pointer' }} />
        case 'email-icon':
            return <img src={getImgPath('/img/email-icon.svg')} onError={handleImgError} />
        case 'email-icon-error':
            return <img src={getImgPath('/img/email-icon-error.svg')} onError={handleImgError} />
        case 'flag-icon':
            return <img src={getImgPath('/img/flag-icon.svg')} onError={handleImgError} />
        case 'flag-icon-error':
            return <img src={getImgPath('/img/flag-icon-error.svg')} onError={handleImgError} />
        case 'phone-icon':
            return <img src={getImgPath('/img/phone-icon.svg')} onError={handleImgError} />
        case 'phone-icon-error':
            return <img src={getImgPath('/img/phone-icon-error.svg')} onError={handleImgError} />
        case 'filter-left-arrow':
            return <img src={getImgPath('/img/filter-left-arrow.svg')} onError={handleImgError} />
        case 'lock-icon':
            return <img src={getImgPath('/img/lock-icon.svg')} onError={handleImgError} />
        case 'lock-icon-error':
            return <img src={getImgPath('/img/lock-icon-error.svg')} onError={handleImgError} />
        case 'view-icon':
            return <img src={getImgPath('/img/view-icon.svg')} onError={handleImgError} />
        case 'sortBy':
            return <img src={getImgPath('/img/sortBy.png')} onError={handleImgError} />
        case 'sort-arrow-down':
            return <img src={getImgPath('/img/sort-arrow-down.png')} onError={handleImgError} />
        case 'sort-arrow-up':
            return <img src={getImgPath('/img/sort-arrow-up.png')} onError={handleImgError} />
        case 'login_error':
            return <img src={getImgPath('/img/login_error.png')} onError={handleImgError} style={{ marginRight: '10px' }} />
        case 'ic_fb.svg':
            return <img id="imgFb" src={getImgPath('/img/ic_fb.svg')} onError={handleImgError} />
        case 'ic_twitter.svg':
            return <img id="imgTwitter" src={getImgPath('/img/ic_twitter.svg')} onError={handleImgError} />
        case 'ic_instagram.svg':
            return <img id="imgInsta" src={getImgPath('/img/ic_instagram.svg')} onError={handleImgError} />
        case 'ic_linkedin.svg':
            return <img id="imgLinkedin" src={getImgPath('/img/ic_linkedin.svg')} onError={handleImgError} />
        case 'ic_google_plus.svg':
            return <img id="imgGp" src={getImgPath('/img/ic_google_plus.svg')} onError={handleImgError} />
        case 'ic_youtube.svg':
            return <img id="imgYoutube" src={getImgPath('/img/ic_youtube.svg')} onError={handleImgError} />
        case 'filter-web':
            return <img src={getImgPath('/img/filter-web.png')} onError={handleImgError} />
        case 'filter_ac':
            return <img src={getImgPath('/img/filter_ac.png')} onError={handleImgError} />
        case 'filter_seater':
            return <img src={getImgPath('/img/filter_seater.png')} onError={handleImgError} />
        case 'filter_sleeper':
            return <img src={getImgPath('/img/filter_sleeper.png')} onError={handleImgError} />

        case 'filter_ac_active':
            return <img src={getImgPath('/img/filter_ac_active.png')} onError={handleImgError} />
        case 'filter_seater_active':
            return <img src={getImgPath('/img/filter_seater_active.png')} onError={handleImgError} />
        case 'filter_sleeper_active':
            return <img src={getImgPath('/img/filter_sleeper_active.png')} onError={handleImgError} />

        case 'filter_morning':
            return <img src={getImgPath('/img/filter_morning.png')} onError={handleImgError} />
        case 'filter_noon':
            return <img src={getImgPath('/img/filter_noon.png')} onError={handleImgError} />
        case 'filter_evening':
            return <img src={getImgPath('/img/filter_evening.png')} onError={handleImgError} />
        case 'filter_night':
            return <img src={getImgPath('/img/filter_night.png')} onError={handleImgError} />
        case 'filter_morning_active':
            return <img src={getImgPath('/img/filter_morning_active.png')} onError={handleImgError} />
        case 'filter_noon_active':
            return <img src={getImgPath('/img/filter_noon_active.png')} onError={handleImgError} />
        case 'filter_evening_active':
            return <img src={getImgPath('/img/filter_evening_active.png')} onError={handleImgError} />
        case 'filter_night_active':
            return <img src={getImgPath('/img/filter_night_active.png')} onError={handleImgError} />
        case 'filter_drop':
            return <img src={getImgPath('/img/filter_drop.png')} onError={handleImgError} />
        case 'filter_down_active':
            return <img src={getImgPath('/img/filter_down_active.png')} onError={handleImgError} />
        case 'filter_drop_down':
            return <img src={getImgPath('/img/filter_drop_down.png')} onError={handleImgError} />
        case 'trip_icon':
            return <img src={getImgPath('/img/trip_icon.png')} onError={handleImgError} />
        case 'ex_icon':
            return <img src={getImgPath('/img/ex_icon.png')} onError={handleImgError} />
        case 'close_icon':
            return <img src={getImgPath('/img/close_icon.png')} onError={handleImgError} />
        case 'success_icon':
            return <img src={getImgPath('/img/success_icon.png')} onError={handleImgError} />
        case 'fail_icon':
            return <img src={getImgPath('/img/fail_icon.png')} onError={handleImgError} />
        case 'cancel_pnr':
            return <img src={getImgPath('/img/cancel_pnr.png')} onError={handleImgError} />
        case 'txn_pwd':
            return <img src={getImgPath('/img/txn_pwd.png')} onError={handleImgError} />
        case 'cancel_phone':
            return <img src={getImgPath('/img/cancel_phone.png')} onError={handleImgError} />
        case 'pnr_error':
            return <img src={getImgPath('/img/pnr_error.svg')} onError={handleImgError} />
        case 'exicon':
            return <img src={getImgPath('/img/exicon.png')} onError={handleImgError} />
        case 'tt-start-icon':
            return <img src={getImgPath('/img/tt-start-icon.svg')} onError={handleImgError} />
        case 'tt-down-arrow':
            return <img src={getImgPath('/img/tt-down-arrow.svg')} onError={handleImgError} />
        case 'tt-end-icon':
            return <img src={getImgPath('/img/tt-end-icon.svg')} onError={handleImgError} />
        case 'google_play_store':
            return <img src={getImgPath('/img/google_play_store.png')} onError={handleImgError} />
        case 'apple_store_non_srp':
            return <img src={getImgPath('/img/apple_store_non_srp.png')} onError={handleImgError} />
        case 'login':
            return <img src={getImgPath('/img/login.svg')} onError={handleImgError} />
        case 'SearchDropIcon':
            return <img src={getImgPath('/img/SearchIcon.svg')}
                style={{
                    position: 'absolute',
                    left: '15px',
                    fill: '#666',
                    height: '18px',
                    width: '18px',
                    zIndex: '1'
                }}
                onError={handleImgError} />
        default:
            return null;
    }
}